import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

import { getUserID, getVisitEmail } from "~/visits/utils/visitCookies";

export var bugsnagClient = Bugsnag.start({
  apiKey: "bbfd521672bd47a3243638a182d35ac2",
  plugins: [new BugsnagPluginReact()],
  enabledReleaseStages: ["production", "staging"],
  releaseStage: process.env.NODE_ENV,
  otherOptions: {},
  onError: function (event) {
    event.setUser(getUserID(), getVisitEmail());
  },
});

export function logError(error, path, data, showAlert = false) {
  // ADD BUGSNAG
  // bugsnagClient.notify(error);
  // bugsnagClient.notify(error, {
  Bugsnag.setUser(getUserID(), getVisitEmail());
  Bugsnag.notify(error, function (event) {
    event.addMetadata("api", {
      path: path,
      data: data,
    });
  });

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx

    console.log("[logError4] error.response: ", error.response);
    console.log("[logError5] error.response.data: ", error.response.data);
    console.log("[logError6] error.response.status: ", error.response.status);
    console.log("[logError7] error.response.headers: ", error.response.headers);
    if (showAlert) {
      alert(`Error: ${error.response.data}`);
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log("[logError1] error.request: ", error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log("[logError2] Error: ", error.message);
  }
  console.log("[logError3] error.config: ", error.config);
}
